import * as React from "react"
import RandomPersonnelGrid from "./RandomPersonnelGrid"

export default class ConsortiumPersonnel extends React.PureComponent {
  render() {
    return <RandomPersonnelGrid isConsortium />
  }
}